import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useUser } from '@civic/auth-web3/react';
const logo = 'https://hefafnsdx7xk1nzg.public.blob.vercel-storage.com/corre_logo.PNG';

const NAV_ITEMS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'send', label: 'Send' },
  { id: 'receive', label: 'Receive' },
  { id: 'save', label: 'Save' },
  { id: 'invest', label: 'Invest' },
  { id: 'logout', label: 'Logout' },
];

export default function DashboardNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signOut } = useUser();
  const [isLogoutLoading, setIsLogoutLoading] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNav = async (id) => {
    setIsMobileMenuOpen(false); // Close menu on navigation
    if (id === 'logout') {
      try {
        setIsLogoutLoading(true);
        await signOut();
        navigate('/');
      } catch (err) {
        logger.error('Logout failed:', err);
      } finally {
        setIsLogoutLoading(false);
      }
      return;
    }
    if (id === 'save') {
      navigate('/pools');
    } else if (id === 'invest') {
      navigate('/invest');
    } else {
      navigate(`/${id === 'dashboard' ? 'dashboard' : id}`);
    }
  };

  return (
    <nav className="dashboard-navbar-horizontal">
      <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <img 
          src={logo} 
          alt="Corre Logo" 
          style={{
            height: '40px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
        <h1 style={{
          margin: 0,
          color: '#333',
          fontSize: '2rem',
          fontWeight: 'bold',
          fontFamily: 'Inter, sans-serif'
        }}>Corre</h1>
        <button className="hamburger-menu" onClick={toggleMobileMenu} aria-label="Toggle menu" aria-expanded={isMobileMenuOpen}>
          {isMobileMenuOpen ? '✕' : '☰'} {/* Unicode icons for close/hamburger */}
        </button>
      </div>
      <div className={`nav-right${isMobileMenuOpen ? ' open' : ''}`}>
        {NAV_ITEMS.map(item => (
          <button
            key={item.id}
            className={`nav-link-horizontal${location.pathname.includes(item.id) || (item.id === 'dashboard' && location.pathname === '/dashboard') ? ' active' : ''}`}
            onClick={() => handleNav(item.id)}
            disabled={item.id === 'logout' && isLogoutLoading}
          >
            {item.id === 'logout' && isLogoutLoading ? 'LOGGING OUT...' : item.label}
          </button>
        ))}
        <button className="help-btn-horizontal" onClick={() => { handleNav('help'); /* Or some other help action */ setIsMobileMenuOpen(false);}} title="Help">
          <span style={{fontSize: '1.5rem'}}>?</span>
        </button>
      </div>
    </nav>
  );
}
